import * as ApiLocations from "api-calls/ApiLocations";
import { apiGetAxios } from "api-calls/ApiCommands";

export const getCustomerTheme = async () => {
  try {
    const url = await ApiLocations.getCustomerTheme();
    const theme = await apiGetAxios(url);
    return theme;
  } catch (error) {
    // Log more detailed error information
    if (error && typeof error === 'object') {
      console.error("Error fetching customer theme:", {
        message: error.message || 'Unknown error',
        data: error.data,
        status: error.status,
        error: error
      });
    } else {
      console.error("Error fetching customer theme:", error);
    }
    return {}; // Return empty object on error
  }
};
